import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button, Table } from 'antd';
import { apis } from '../api/index.js';
import { eventListener, getImageWithToken } from '../utils';

class ApplyImgList extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    hideImgList: PropTypes.func.isRequired,
    selectedDicom: PropTypes.object,
    onSubmit: PropTypes.func,
    history: PropTypes.object,
  };

  state = {
    visible: this.props.visible,
    confirmLoading: false,
    newImgList: [],
    selectedRows: [],
    productionId: '101',
    pageId: '10018',
  };
  componentDidUpdate(prevProps) {
    const { visible, selectedDicom } = this.props;
    if (prevProps.visible !== visible) {
      selectedDicom.diagId = selectedDicom.diagId || selectedDicom.id;
      apis.applyRelatedDrList(selectedDicom.diagId).then(res => {
        if (res.code === '0') {
          this.setState({ newImgList: res.data });
        } else if (res.code === '1009') this.props.history.push('/login');
      });
      this.setState({ visible, selectedDicom });
    }
  }

  handleOk = e => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0004' };
    eventListener({ ...eventData, elementId: 'ns-005' });

    e.preventDefault();
    this.props.onSubmit(this.state.selectedRows);
    this.setState({ visible: false });
    this.props.hideImgList();
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = type => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0004' };
    let elementId;
    if (type === 'cancel') elementId = 'ns-004';
    else if (type === 'close') elementId = 'ns-006';
    elementId && eventListener({ ...eventData, elementId });

    this.props.hideImgList();
    //点击关闭按钮后初始化预览图片
    this.setState({ visible: false });
  };

  getImgs = (text, item, index) => {
    let url = `/v1/picl/aets/piclarc/rs/studies/${item.studyUid}/series/${item.seriesUid}/instances/${item.sopInstanceId}/frames/1/rendered`;
    return (
      <span id={`preview-img${index}`} key={index}>
        {getImageWithToken(url, `preview-img${index}`, 3)}
      </span>
    );
  };

  getColumns = () => {
    return [
      {
        title: '时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: '30%',
      },
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: '30%',
      },
      {
        title: '影像',
        dataIndex: '',
        key: 'img',
        width: '40%',
        render: (text, record, index) => (
          <span>{this.getImgs(text, record, index)}</span>
        ),
      },
    ];
  };

  render() {
    let { visible, confirmLoading } = this.state;
    const columns = this.getColumns();
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRows });
      },
    };

    const buttons = [
      <Button
        key="cancel"
        onClick={() => this.handleCancel('cancel')}
        type="default"
        className="btn-cancel"
      >
        取消
      </Button>,
      <Button
        key="submit"
        type="primary"
        loading={confirmLoading}
        onClick={this.handleOk}
        className="btn-ok"
      >
        确定
      </Button>,
    ];
    return (
      <div className="group-modal" id="applyImgList">
        <Modal
          title="更多影像"
          visible={visible}
          width="900px"
          height="600px"
          className="group-manager group-manager-apply"
          onCancel={() => this.handleCancel('close')}
          footer={buttons}
          centered={true}
          keyboard={false}
          maskClosable={false}
        >
          <div className="report-list-modal">
            <div style={{ color: '#f00', marginBottom: '10px' }}>
              提示：已存在于申请单中的影像多次提交不会重复添加。
            </div>
            <Table
              columns={columns}
              dataSource={this.state.newImgList}
              rowSelection={rowSelection}
              rowKey={record => record.dicomDrId}
              pagination={false}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default ApplyImgList;
